module.exports = "/_next/static/images/logo-bf417bbbd2e7434a51e12f0d46295eae.svg";